import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, ButtonGroup, Divider, IconButton, IconButtonProps, useDisclosure } from '@chakra-ui/react';
import IconRemove from 'assets/icons/icon-remove.svg?react';
import React from 'react';

type ButtomRemoveProps = Partial<IconButtonProps> & {
  clean?: boolean;
  message?: string;
}

export default function ButtonRemove({ clean, onClick, message = 'Você tem certeza disso? Você não pode desfazer essa ação', ...props }: ButtomRemoveProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef()

  if (!clean)
    props = {
      ...props, 
      bgColor: '#FDEDF0',
      color: '#DF1C41'
    }
  return (
    <>
      <IconButton
        variant="ghost"
        size="sm"
        icon={<IconRemove />}
        {...props}
        aria-label="Remover"
        onClick={(e) => {
          if (onClick) {
            if (!clean)
              onOpen();
            else 
              onClick(e);
          }
        }}
      />
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Confirmação
            </AlertDialogHeader>

            <AlertDialogBody mt="10px">
              {message}
            </AlertDialogBody>

            <Divider />

            <AlertDialogFooter>
              <ButtonGroup>
                <Button ref={cancelRef} onClick={onClose}>
                  Cancelar
                </Button>
                <Button 
                  variant="primary" 
                  size="sm" 
                  onClick={(e) => {
                    onClose();
                    if (onClick)
                      onClick(e);
                  }}>  
                  Confirmar
                </Button>
              </ButtonGroup>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
